var bind = function (fn, me) {
  return function () {
    return fn.apply(me, arguments);
  };
};
var $ = jQuery;

/* --------------------------------------------
  Initialization
  @Params: jQuery element
  @Returns: none
*/
var Intro = function ($element) {
  this.isParentSoleil = false;
  this.handleClick = bind(this.handleClick, this);

  this.$intro = $element;
  this.$steps = this.$intro.find(".js-intro__step");
  this.$stepsActions = this.$steps.find(".js-step__action");

  this.$intro.addClass("show");
  this.$steps.first().addClass("intro__step--active");

  this.$stepsActions.on("click", this.handleClick);
};

/* --------------------------------------------
  Update suggestions
  @Params: data
  @Returns: none
*/
Intro.prototype.handleClick = function (e) {
  var current = $(e.currentTarget),
    targetType = current.attr("data-target-type"),
    targetID = current.attr("data-target-id"),
    targetValues = current.attr("data-target-values");

  if (targetValues) {
    this.setValues(JSON.parse(targetValues));
  }

  if (targetType == "step") {
    this.handleStep(targetID);
  } else if (targetType == "action") {
    this.handleAction(targetID);
  }
};

Intro.prototype.setValues = function (values) {
  this.values = values;
};

Intro.prototype.handleStep = function (target) {
  var currentStep = this.$steps.filter(".intro__step--active");
  targetStep = this.$steps.filter("#" + target);

  if (targetStep) {
    currentStep.removeClass("intro__step--active");
    targetStep.addClass("intro__step--active");
  }
};

Intro.prototype.handleAction = function (target) {
  if (this.values) {
    if (this.values.parentSoleil) {
      $("#parent_soleil").prop("checked", "checked");
    }
  }

  $(".js-support__input")
    .filter("#" + target)
    .prop("checked", "checked");
  $(".js-support__input").trigger("change");

  $(".js-dimmable").removeClass("dimmable--dimmabled");
  $(".js-dimmable").find("input, select, a, button").prop("disabled", false);

  this.delete();
  $(".js-input-autocomplete").focus();
};

Intro.prototype.delete = function () {
  var _this = this;
  _this.$stepsActions.off("click", this.handleClick);
  _this.$intro.removeClass("show");

  setTimeout(function () {
    _this.$intro.remove();
  }, 500);
};

module.exports = Intro;
